import { css, jsx } from '@emotion/core';
import { Radio } from 'antd';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Container from '@/src/shared/components/Container';
import Hero from '@/src/shared/components/Hero';
import Layout from '@/src/shared/components/Layout';
import withMembershipAccessWrap from '@/src/shared/components/MembershipPageWrap';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { ABOUT_ACCESS } from '@/src/shared/constants';
import CommitteeSort from '@/src/staffDirectory/CommitteeSort';
import DivisionSort from '@/src/staffDirectory/DivisionSort';
import NameSort from '@/src/staffDirectory/NameSort';
import StateSort from '@/src/staffDirectory/StateSort';
import SubjectSort from '@/src/staffDirectory/SubjectSort';
import { colors } from '@/styles';

const style = {
  groupWrapper: css`
    margin-bottom: 24px;
    display: flex;
    .ant-radio-button-wrapper-checked {
      background: ${colors.secondaryBlue} !important;
      border-color: ${colors.secondaryBlue} !important;
      box-shadow: -1px 0 0 0 ${colors.secondaryBlue} !important;
    }
    .ant-radio-button-wrapper-checked::before {
      background: ${colors.secondaryBlue} !important;
      border-color: ${colors.secondaryBlue} !important;
      box-shadow: -1px 0 0 0 ${colors.secondaryBlue} !important;
    }
    .ant-radio-button-wrapper-checked::after {
      background: ${colors.secondaryBlue} !important;
      border-color: ${colors.secondaryBlue} !important;
      box-shadow: -1px 0 0 0 ${colors.secondaryBlue} !important;
    }
  `,
  inGroupStyle: css`
    padding: 0px 10px !important;
    font-size: 1.2rem !important;
    font-weight: bold;
    background-color: white;
    box-shadow: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${colors.secondaryBlue};
    min-width: 74px;
    &:hover,
    &:focus,
    &:active {
      border-color: ${colors.secondaryBlue} !important;
      color: ${colors.secondaryBlue};
    }
  `,
  sortSection: css`
    display: flex;
    /* background: white; */
  `,
  rowOne: css`
    display: flex;
  `,
  text: css`
    font-size: 1.6rem;
    /* margin: auto; */
  `,
  labelGroup: css`
    align-self: center;
    padding-right: 8px;
    font-size: 1.6rem;
    font-weight: bolder;
    margin-bottom: 55px;
    display: flex;
    flex-direction: column;
  `,
};

const StaffDirectory = () => {
  const router = useRouter();
  const [sort, setSort] = useState('name');

  const { query } = router;

  const handleSort = e => {
    const {
      target: { value },
    } = e;
    const url = `/about/staff-directory?type=${value}`;
    router.push(url, url, { shallow: true });
    setSort(value);
  };

  useEffect(() => {
    if ('type' in query) {
      const { type } = query;
      setSort(type);
    }
  }, [query]);

  return (
    <Layout>
      <Hero title="Staff Directory" />
      <Section bgColor="gray">
        <Container>
          <div css={style.sortSection}>
            <div css={style.groupWrapper}>
              <div css={style.labelGroup}>
                <p>Sort by</p>
              </div>
              <Radio.Group buttonStyle="solid" value={sort}>
                <div>
                  <Radio.Button value="name" css={style.inGroupStyle} onChange={e => handleSort(e)}>
                    Name
                  </Radio.Button>
                  <Radio.Button
                    value="division"
                    css={style.inGroupStyle}
                    onChange={e => handleSort(e)}
                  >
                    Division
                  </Radio.Button>
                  <Radio.Button
                    value="state"
                    css={style.inGroupStyle}
                    onChange={e => handleSort(e)}
                  >
                    State
                  </Radio.Button>
                </div>
                <div>
                  <Radio.Button
                    value="committee"
                    css={style.inGroupStyle}
                    onChange={e => handleSort(e)}
                  >
                    Committee
                  </Radio.Button>
                  <Radio.Button
                    value="subject"
                    css={style.inGroupStyle}
                    onChange={e => handleSort(e)}
                  >
                    Subject
                  </Radio.Button>
                </div>
              </Radio.Group>
            </div>
          </div>
          {sort === 'name' && <NameSort />}
          {sort === 'state' && <StateSort />}
          {sort === 'committee' && <CommitteeSort />}
          {sort === 'subject' && <SubjectSort />}
          {sort === 'division' && <DivisionSort />}
        </Container>
      </Section>
      <WebLogImage path="/about/staff-directory" title="Staff Directory" />
    </Layout>
  );
};

export default withMembershipAccessWrap(StaffDirectory, ABOUT_ACCESS.STAFF_DIRECTORY);
